<template>
    <el-dialog
            append-to-body
            width="600px"
            :visible.sync="visible"
            title="问卷题目列表"
            @closed="dialogCloseHandler"
            @submit.native.prevent
            custom-class="project-container">
        <ListLayout class="order-repair-step3-index-wrap">
            <el-table slot="table-list" :ref="tableRef" style="height: 400px;" class="background-table"
                      :data="page.list">
                <el-table-column type="expand">
                    <template slot-scope="props" v-if="props.row.type === 'rate'||props.row.type === 'radio'||props.row.type === 'checkbox'">
                        <el-card class="box-card">
                            <div v-for="item in props.row.paperInfoOptions" :key="item.orderNumber"
                                 class="text item">
                                {{'选项' + item.orderNumber }}、{{item.content}} {{item.otherContent !=
                                undefined?' - 不满意原因项('+item.otherContent+')':''}}
                            </div>
                        </el-card>
                    </template>
                </el-table-column>

 

                <el-table-column type="index" width="50px"></el-table-column>
                <el-table-column label="题目名称" show-overflow-tooltip prop="title"></el-table-column>
                <el-table-column label="题型" show-overflow-tooltip>
                    <template slot-scope="props">
                        <el-tag :type="getType(props.row.type)">{{props.row.typeName}}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </ListLayout>

    </el-dialog>
</template>

<script>
    export default JBoot({
        props: {},

        data() {
            return {
                moduleName: 'paper',
                listMethod: 'queryTitleAndOtion',
                tableRef: 'pageTableRef',
                visible: false
            }
        },

        computed: {},


        methods: {

            __listInit() {
            },
            __formInit() {
            },


            getType(type) {
                switch (type) {
                    case "input":
                        return "success";
                    case "radio":
                        return "info";
                    case  "checkbox":
                        return "warning";
                    case "select":
                        return "danger";
                    case "rate":
                        return '';
                }
            },

            getQueryParam() {
                return {
                    "infoId": this.parentParam.infoId == undefined ? undefined : this.parentParam.infoId,
                }
            },

            initPageInfo(response) {
                this.$set(this, 'page', {
                    list: response.titles || [],
                })
            },

            show(params) {
                this.parentParam = params || {};
                this.title = this.parentParam.title;
                this.readonly = this.parentParam.readonly;
                this.visible = true;
                this.id = this.parentParam.id;
                this.selectionRowMap = this.parentParam.selectionRowMap
                this.$nextTick(function () {
                    this.queryHandler();
                });
            },

        },

        watch: {}
    }).form().list('pager').build();
</script>

<style lang="scss">
    .project-container {
        & > .el-dialog__body {

            min-height: 400px;

            & > .el-table {
                border: 1px solid #efefef !important;
                border-right: none !important;
                height: 100%;
            }
        }

        & > .el-dialog__footer {
            & > .footer-wrap {
                & > .el-pagination {
                    float: left;

                    & button {
                        padding: 0 !important;
                    }
                }

                & > .right-wrap {
                    & > span {
                        font-size: 13px;
                        margin-right: 5px;
                        color: #606266;

                        & > strong {
                            color: #333333;
                            margin: 0 2px;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/paperTitleAndOption.vue